"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intersection = void 0;
function intersection(array1, array2) {
    if (!Array.isArray(array1) || !Array.isArray(array2)) {
        return [];
    }
    var uniqueArray1 = createUniqueArray(array1);
    var uniqueArray2 = createUniqueArray(array2);
    return uniqueArray1.filter(function (value) { return uniqueArray2.indexOf(value) !== -1; });
}
exports.intersection = intersection;
var createUniqueArray = function (array) {
    return array.filter(function (elem, index, self) { return index === self.indexOf(elem); });
};
//# sourceMappingURL=intersection.js.map